var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, alpha, useTheme } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers";
import { useGetContrastColor } from "../../hooks/useGetContrastColor";
import { PickersDayStyledBadge } from "./PickersDayStyledBadge";
import { dayChangeHandler } from "./dateTimeUtils";
import { useSkipDaySlashAnimation } from "./useSkipDaySlashAnimation";
import { useSkipDaysPickerValues } from "./useSkipDaysPickersValues";
export const SkipDaysCustomPickersDay = (_a) => {
    var { badgeProps, currentMonth, customDaySelect, // placeholder, may not need this
    daysForCurrentMonth, handleOpenWarningModal, handleUpdateSkipDay, mutatingDates, onDaySelect, setDayToSkip } = _a, rest = __rest(_a, ["badgeProps", "currentMonth", "customDaySelect", "daysForCurrentMonth", "handleOpenWarningModal", "handleUpdateSkipDay", "mutatingDates", "onDaySelect", "setDayToSkip"]);
    const { day } = rest;
    const theme = useTheme();
    const { isDisabledDay, isInCurrentMonth, isMutating, isSkipDay, selectedTextColor, skippedDayBackgroundColor, skippedDayBorder, targetDay, updatedBadgeProps, } = useSkipDaysPickerValues(badgeProps, currentMonth, day, daysForCurrentMonth, mutatingDates);
    const { showSlash, slashAnimation, spinnerColor, wasSkipDay } = useSkipDaySlashAnimation(isMutating, isSkipDay, isInCurrentMonth);
    return (_jsx(PickersDayStyledBadge, Object.assign({}, Object.assign({ day }, updatedBadgeProps), { children: _jsxs(Box, Object.assign({ sx: { position: "relative", display: "inline-flex" } }, { children: [_jsx(PickersDay, Object.assign({}, rest, { outsideCurrentMonth: !isInCurrentMonth, selected: !!isSkipDay || (isMutating && wasSkipDay), disabled: isDisabledDay || !isInCurrentMonth, sx: {
                        // I would have preferred a styled component here, but there are prop conflicts that I can't figure out.
                        "&.MuiPickersDay-root": {
                            color: theme.palette.primary.main,
                            fontWeight: 900,
                        },
                        "&.MuiPickersDay-root.Mui-selected": {
                            color: selectedTextColor,
                            backgroundColor: skippedDayBackgroundColor,
                            border: isMutating ? "none" : skippedDayBorder,
                        },
                        "&.MuiPickersDay-root.Mui-disabled": {
                            color: alpha(theme.palette.text.disabled, 0.15),
                        },
                    }, onDaySelect: customDaySelect
                        ? customDaySelect
                        : dayChangeHandler(handleOpenWarningModal, handleUpdateSkipDay, isDisabledDay, isSkipDay, setDayToSkip, targetDay) })), showSlash && (_jsx(Box, { sx: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "110%",
                        height: "2px",
                        backgroundColor: theme.palette.warning.main,
                        transform: "translate(-50%, -50%) rotate(-45deg)",
                        transformOrigin: "center",
                        pointerEvents: "none",
                        animation: slashAnimation,
                    } })), isMutating && isInCurrentMonth && (_jsx(Box, Object.assign({ sx: {
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                        zIndex: 1,
                    } }, { children: _jsx(CircularProgress, { size: 36, thickness: 2, sx: { color: spinnerColor } }) })))] })) })));
};
export const SimpleCustomPickersDay = (props) => {
    const theme = useTheme();
    const selectedDayBackground = alpha(theme.palette.warning.light, 0.1);
    const contrastColor = useGetContrastColor(selectedDayBackground);
    return (_jsx(PickersDay, Object.assign({}, props, { sx: {
            // I would have preferred a styled component here, but there are prop conflicts that I can't figure out.
            "&.MuiPickersDay-root": {
                color: theme.palette.primary.main,
                fontWeight: 900,
            },
            "&.MuiPickersDay-root.Mui-selected": {
                color: contrastColor,
                backgroundColor: selectedDayBackground,
                border: `2px solid ${theme.palette.primary.main}`,
            },
            "&.MuiPickersDay-root.Mui-disabled": {
                color: alpha(theme.palette.text.disabled, 0.15),
            },
        } })));
};
